module.exports = __webpack_public_path__ + "static/img/banner-img.7529f9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/banner-img.png
// module id = cTks
// module chunks = 44